import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTimeoutCall } from "src/hooks/useTimeoutCall";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setTriggerTimeCheck } from "src/redux/slices/generatorFeaturesSlice";
import {
  setEntryLockingDate,
  setTimeZone,
  setTriggerTotalsUpdate,
} from "src/redux/slices/generatorSlice";

import TimeInputWithTimeZone, {
  type ITimeInputWithTimeZone,
} from "../TimeInputWithTimeZone/TimeInputWithTimeZone";

interface Props extends ITimeInputWithTimeZone {
  sectionIndex?: number | undefined;
  data: { type: string };
  value: { time: string; type: string };
}

const LockTimeInput = ({ idx, sectionIndex, data, ...cell }: Props) => {
  const dispatch = useDispatch();
  const timeoutCall = useTimeoutCall();
  const { features } = useSelector(state => state.generatorSlice);
  const [error, setError] = useState("");
  useEffect(() => {
    if (cell.isOverlay) return;
    if (idx === 0) {
      // if (cell.value.time) {
      //   dispatch(setLock24({ time: cell.value, sectionIdx: sectionIndex }));
      // }
      // dispatch(setSaveLockAvailable(true));
      if (data?.type || cell?.value?.type)
        dispatch(setTimeZone(data?.type || cell?.value?.type));
    }
  }, [idx, sectionIndex, cell, data?.type, dispatch]);

  useEffect(() => {
    if (cell.isOverlay) return;

    if (features?.timeValidation?.[cell.id]) {
      setError(features?.timeValidation?.[cell.id]);
    } else {
      setError("");
    }
  }, [cell, features]);

  const onTimeChange = () => {
    if (idx === 0) {
      dispatch(setEntryLockingDate(dayjs().format("YYYY-MM-DD")));
    }
    timeoutCall(
      "time-check",
      () => {
        dispatch(setTriggerTimeCheck(Math.random()));
        dispatch(setTriggerTotalsUpdate(Math.random()));
      },
      3000,
    );
  };

  return (
    <TimeInputWithTimeZone
      {...cell}
      idx={idx}
      error={error}
      onTimeChange={onTimeChange}
      sectionIndex={sectionIndex}
      className={`lock-${idx}`}
    />
  );
};
export default LockTimeInput;
